<template>
  <form @submit.prevent="onsubmit">
    <va-input
      v-model="username"
      label="用户名"
      :error="!!usernameErrors.length"
      :error-messages="usernameErrors"
    />

    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    />

    <div class="d-flex justify--center mt-3">
      <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
    </div>
  </form>
</template>

<script>

import authApi from '../../../api/auth'

export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      usernameErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.usernameErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.usernameErrors = this.username ? [] : ['username is required']
      this.passwordErrors = this.password ? [] : ['password is required']
      if (!this.formReady) {
        return
      }
      authApi.login({
        username: this.username,
        password: this.password,
      }).then(response => {
        localStorage.setItem('token', response.token)
        localStorage.setItem('username', this.username)
        this.$router.push({ name: 'dashboard' })
      }).catch(error => {
        this.showToast('账号或密码错误，请重试!', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}
</script>

<style lang="scss">
</style>
